import React from "react";
import {
  IconFileCheck,
  IconArrowLeft,
  // IconLock,
  // IconCreditCard,
  IconCircleCheck,
} from "@tabler/icons-react";
import SectionCard from "./SectionCard";
import Button from "../elements/form/Button";
import {
  COUNTRIES,
  // FLAT_FEE_USD_BY_COUNTRY,
  // APPROX_FX_RATE_TO_USD,
} from "../../constants/countryData";
import type { ICompanyDetails, CountryCode } from "../../store/@types/portal";
import type { IService } from "../../store/@types/service";
import type { IDocument } from "../../store/@types/document";

type IGenerateDocumentsStep = {
  countryCode: CountryCode | "";
  countryName: string;
  services: IService[];
  companyDetails: ICompanyDetails;
  generatingDocuments: boolean;
  generatedDocuments: IDocument[] | null;
  onBack: () => void;
  onGenerateDocuments: () => void;
};

const GenerateDocumentsStep: React.FC<IGenerateDocumentsStep> = ({
  countryCode,
  countryName,
  services,
  companyDetails,
  generatingDocuments,
  generatedDocuments,
  onBack,
  onGenerateDocuments,
}) => {
  const country = COUNTRIES.find((c) => c.code === countryCode);
  // const feeUsd = countryCode ? FLAT_FEE_USD_BY_COUNTRY[countryCode] : 1000;
  // const fxRate = countryCode ? APPROX_FX_RATE_TO_USD[countryCode] : null;
  // const approxLocal = fxRate
  //   ? Math.round(feeUsd * fxRate).toLocaleString()
  //   : null;

  return (
    <SectionCard
      icon={<IconFileCheck size={20} stroke={1.75} />}
      title="Generate Your Documents"
    >
      <div className="space-y-6">
        <div className="rounded-xl bg-gray-50/10 px-5 py-5">
          <p className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <IconCircleCheck size={16} className="text-primary-500" />
            Selected Services — {countryName || country?.name}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {services.map((service) => (
              <span
                key={service.id}
                className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-white"
              >
                <IconCircleCheck size={13} />
                {service.name}
              </span>
            ))}
          </div>
          {companyDetails.company_name && (
            <p className="mt-3 text-sm text-slate-500">
              {companyDetails.company_name}
            </p>
          )}
        </div>

        {/*
        <div className="rounded-xl border border-amber-200 bg-amber-50/10 px-5 py-6 text-center sm:px-8">
          <p className="flex items-center justify-center gap-2 text-sm font-semibold text-amber-800">
            <IconLock size={16} />
            Payment Required to Generate Documents
          </p>
          <p className="mt-1 text-xs text-amber-700">
            One flat fee covers all selected services
          </p>

          <div className="mx-auto mt-4 max-w-sm rounded-xl border border-dashed border-amber-300 bg-white px-6 py-5">
            <p className="text-xs font-medium uppercase tracking-wide text-slate-400">
              Total Amount Due
            </p>
            <p className="mt-1 text-4xl font-bold text-amber-500">
              ${feeUsd.toLocaleString()}.00
            </p>
            <p className="mt-1 text-xs text-slate-400">
              {approxLocal && country
                ? `≈ ${country.currencySymbol}${approxLocal} · `
                : ""}
              Covers all {services.length} selected service
              {services.length === 1 ? "" : "s"}
            </p>
            <div className="mt-3 flex flex-wrap justify-center gap-2">
              {services.map((service) => (
                <span
                  key={service.id}
                  className="inline-flex items-center gap-1 rounded-full bg-primary-50/20 px-2.5 py-1 text-xs font-semibold text-primary-600"
                >
                  <IconCircleCheck size={12} />
                  {service.name}
                </span>
              ))}
            </div>
          </div>

          <Button
            title={`Pay $${feeUsd.toLocaleString()}.00 & Generate Documents`}
            type="button"
            onHandler={onGenerateDocuments}
            loading={generatingDocuments}
            icon={<IconCreditCard size={18} />}
            bg_color="bg-amber-500"
            bg_hoverColor="bg-amber-600"
            className="mx-auto mt-5 w-full max-w-sm justify-center rounded-full sm:w-auto sm:px-8 text-sm"
          />
        </div>
        */}

        {generatedDocuments !== null ? (
          <div className="rounded-xl border border-gray-200 bg-white px-5 py-6">
            <h2 className="text-lg font-semibold text-slate-900">
              Generated Documents
            </h2>
            {generatedDocuments.length === 0 ? (
              <p className="mt-3 text-sm text-slate-500">No document yet</p>
            ) : (
              <ul className="mt-4 space-y-3">
                {generatedDocuments.map((document) => (
                  <li
                    key={document.id}
                    className="flex items-center justify-between gap-4 rounded-lg border border-gray-100 px-4 py-3"
                  >
                    <span className="text-sm font-medium text-slate-800">
                      {document.name}
                    </span>
                    {document.document_file && (
                      <a
                        href={document.document_file}
                        target="_blank"
                        rel="noreferrer"
                        className="text-sm font-semibold text-primary-600 hover:underline"
                      >
                        View document
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <div className="rounded-xl border border-amber-200 bg-amber-50/10 px-5 py-6 text-center sm:px-8">
            <p className="text-sm font-semibold text-amber-800">
              Generate documents for your selected services
            </p>
            <Button
              title="Generate Documents"
              type="button"
              onHandler={onGenerateDocuments}
              loading={generatingDocuments}
              icon={<IconFileCheck size={18} />}
              bg_color="bg-amber-500"
              bg_hoverColor="bg-amber-600"
              className="mx-auto mt-5 w-full max-w-sm justify-center rounded-full sm:w-auto sm:px-8 text-sm"
            />
          </div>
        )}

        <div className="flex items-center pt-5">
          <Button
            title="Back"
            type="button"
            onHandler={onBack}
            icon={<IconArrowLeft size={18} />}
            bg_color="bg-white"
            bg_hoverColor="bg-slate-50"
            text_color="text-slate-700"
            className="rounded-full border border-slate-200"
          />
        </div>
      </div>
    </SectionCard>
  );
};

export default GenerateDocumentsStep;
